import { useEffect, useState } from 'react'
// Imported from their leaf modules rather than the `@/components` barrel: the barrel
// pulls in components that import `@/utils`, creating a cycle that breaks at runtime.
import { headerIds } from '@/components/Surface/Header/Header.data'
import { stepperIds } from '@/components/Surface/Stepper/Stepper.data'

const useLayoutHeight = () => {
  const [headerHeight, setHeaderHeight] = useState(0)
  const [stepperHeight, setStepperHeight] = useState(0)

  useEffect(() => {
    const header = document.getElementById(headerIds.root)
    const hHeight = header?.getBoundingClientRect().height ?? 0

    const stepper = document.getElementById(stepperIds.root)
    const sHeight = stepper?.getBoundingClientRect().height ?? 0

    setHeaderHeight(hHeight)
    setStepperHeight(sHeight)
  }, [])

  return {
    headerHeight,
    stepperHeight,
    layoutOccupiedHeight: headerHeight + stepperHeight,
  }
}

export default useLayoutHeight
